// ? 全局默认配置项
export const CDN_URL = "https://static.zhihaoscm.cn";

// 首页地址（默认）
export const HOME_URL: string = "/myTask/index";

// 登录页地址（默认）
export const LOGIN_URL: string = "/login";

// 认证页地址（默认）
export const AUTHENTICATION_URL: string = "/authentication/authentication";

// 无权限页面
export const NO_PERMISSION_URL: string = "/403";
// 全匹配路由名(默认)
export const MATCH_NAME: string = "matchAll";

// 默认主题颜色
export const DEFAULT_PRIMARY: string = "#1777FF";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/500", "/403"];

// 日期时间选择器格式化
export const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD";

// 时间戳格式化带T
export const LOG_DATE_FORMAT_T = "YYYY-MM-DDTHH:mm:ss";
// 时间戳格式化带T秒为0
export const LOG_DATE_FORMAT_T_0 = "YYYY-MM-DDTHH:mm:00";

// 日志时间戳格式化
export const LOG_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const LOG_DATE_FORMAT_START = "YYYY-MM-DDT00:00:00";
export const LOG_DATE_FORMAT_END = "YYYY-MM-DDT23:59:59";
export const TIME_PICKER_FORMAT = "HH:mm:ss";
// 海康摄像头时间戳格式化
export const HIA_DATE_FORMAT = "YYYYMMDDHHmmss";

//文件导出格式
export const EXPORT_FILE_FORMAT = "YYYYMMDDHHmm";

// 新增、修改弹框宽度
export const DEFAULT_DIALOG_WIDTH = "842px";

// 选项卡最大数量
export const MAX_TAG_NUMBER = 10;

// 数据缺省值
export const DEFAULT_VALUE = "--";

// export const VideoPlayerUrl = "https://minvideo.zhihaoscm.com/VideoPlayer.html?videoUrl=";
export const VideoPlayerUrl = `${import.meta.env.VITE_VIDEO_PLAYER_URL}?{dateRange}token={token}&deviceSerial={deviceSerial}&mode={mode}&origin={origin}&channelNo={channelNo}`;
